import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { FileUploadAwareJsonWriter1mx337tg0y9oj as FileUploadAwareJsonWriter } from '../json/internal/FileUploadAwareJsonWriter.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { Buffer3384y49aj0pxr as Buffer } from '../../../../../../okio-parent-okio/okio/Buffer.mjs';
import { BufferedSinkJsonWriter1xl4ankftitqq as BufferedSinkJsonWriter } from '../json/BufferedSinkJsonWriter.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  fromInt2ii0rejb1w62w as fromInt,
  add2suhfggl4zvkk as add,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { contains3ue2qo8xhmpf1 as contains } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { _Char___init__impl__6a9atx1csff5kwtduxl as _Char___init__impl__6a9atx } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { urlEncoded5v8jd8by0u4 as urlEncode } from './internal/UrlEncode.mjs';
import { Key_getInstance30q5r2nw695ls as Key_getInstance } from '../CustomScalarAdapters.mjs';
import { MapJsonWriter4jz7ym6vbwk4 as MapJsonWriter } from '../json/MapJsonWriter.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KtMap140uvy3s5zad8 as KtMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  HttpHeader1d7ldebjomr00 as HttpHeader,
  HttpMethod_Post_getInstancedk9zwal3qkxy as HttpMethod_Post_getInstance,
  HttpMethod_Get_getInstance1iq7uubvx4wdk as HttpMethod_Get_getInstance,
  Builder2ocxamygt14i4 as Builder,
} from './Http.mjs';
import { Subscription2xxf73xmsvgi0 as Subscription } from '../Subscription.mjs';
import { startsWith26w8qjqapeeq6 as startsWith } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import {
  checkIndexOverflow3frtmheghr0th as checkIndexOverflow,
  listOfvhqybd2zx248 as listOf,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { toMap1vec9topfei08 as toMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { writeAny16i13331zbqlc as writeAny } from '../json/JsonWriters.mjs';
import { uuid4al7pp0fcb8o5 as uuid4 } from '../../../../../../uuid/com/benasher44/uuid/uuid.mjs';
import {
  blackholeSink1e341pykjnhp5 as blackholeSink,
  buffer10rjf0ze3bqic as buffer,
} from '../../../../../../okio-parent-okio/okio/Okio.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function buildGetUrl($this, serverUrl, operation, customScalarAdapters, sendApqExtensions, sendDocument, sendEnhancedClientAwarenessExtensions) {
  return $this.q47(serverUrl, composeGetParams($this, operation, customScalarAdapters, sendApqExtensions, sendDocument, sendEnhancedClientAwarenessExtensions));
}
function composePostParams($this, writer, operation, customScalarAdapters, query, extensionsWriter) {
  var uploads = {_v: null};
  // Inline function 'com.apollographql.apollo.api.json.writeObject' call
  writer.p40();
  writer.r47('operationName');
  writer.b41(operation.operationName());
  writer.r47('variables');
  var uploadAwareWriter = new (FileUploadAwareJsonWriter())(writer);
  // Inline function 'com.apollographql.apollo.api.json.writeObject' call
  uploadAwareWriter.p40();
  operation.p46(uploadAwareWriter, customScalarAdapters, false);
  uploadAwareWriter.q40();
  uploads._v = uploadAwareWriter.u47();
  if (!(query == null)) {
    writer.r47('query');
    writer.b41(query);
  }
  extensionsWriter(writer);
  writer.q40();
  return uploads._v;
}
function composePostParams_0($this, writer, operation, customScalarAdapters, sendApqExtensions, sendEnhancedClientAwarenessExtensions, query) {
  return composePostParams($this, writer, operation, customScalarAdapters, query, extensionsWriter($this, operation.operationId(), sendApqExtensions, sendEnhancedClientAwarenessExtensions));
}
function extensionsWriter($this, apqId, sendApqExtensions, sendEnhancedClientAwarenessExtensions) {
  if (!sendApqExtensions && !sendEnhancedClientAwarenessExtensions) {
    return DefaultHttpRequestComposer$Companion$extensionsWriter$lambda;
  }
  return (_this__u8e3s4) => {
    _this__u8e3s4.r47('extensions');
    // Inline function 'com.apollographql.apollo.api.json.writeObject' call
    _this__u8e3s4.p40();
    if (sendApqExtensions) {
      _this__u8e3s4.r47('persistedQuery');
      // Inline function 'com.apollographql.apollo.api.json.writeObject' call
      _this__u8e3s4.p40();
      _this__u8e3s4.r47('version').d41(1);
      _this__u8e3s4.r47('sha256Hash').b41(apqId);
      _this__u8e3s4.q40();
    }
    if (sendEnhancedClientAwarenessExtensions) {
      _this__u8e3s4.r47('clientLibrary');
      // Inline function 'com.apollographql.apollo.api.json.writeObject' call
      _this__u8e3s4.p40();
      _this__u8e3s4.r47('name').b41('apollo-kotlin');
      _this__u8e3s4.r47('version').b41('4.4.1');
      _this__u8e3s4.q40();
    }
    _this__u8e3s4.q40();
    return Unit_instance;
  };
}
function composeGetParams($this, operation, customScalarAdapters, autoPersistQueries, sendDocument, sendEnhancedClientAwareness) {
  // Inline function 'kotlin.collections.mutableMapOf' call
  var queryParams = LinkedHashMap().gc();
  queryParams.c5('operationName', operation.operationName());
  // Inline function 'com.apollographql.apollo.api.json.buildJsonString' call
  var buffer = new (Buffer())();
  var $this$buildJsonString = new (BufferedSinkJsonWriter())(buffer, null);
  var uploadAwareWriter = new (FileUploadAwareJsonWriter())($this$buildJsonString);
  // Inline function 'com.apollographql.apollo.api.json.writeObject' call
  uploadAwareWriter.p40();
  operation.p46(uploadAwareWriter, customScalarAdapters, false);
  uploadAwareWriter.q40();
  // Inline function 'kotlin.check' call
  if (!uploadAwareWriter.u47().s1()) {
    var message = 'FileUpload and Http GET are not supported at the same time';
    throw IllegalStateException().o(toString(message));
  }
  var variables = buffer.d3y();
  queryParams.c5('variables', variables);
  if (sendDocument) {
    queryParams.c5('query', operation.v47());
  }
  // Inline function 'com.apollographql.apollo.api.json.buildJsonString' call
  var buffer_0 = new (Buffer())();
  // Inline function 'com.apollographql.apollo.api.json.writeObject' call
  var this_0 = new (BufferedSinkJsonWriter())(buffer_0, null);
  this_0.p40();
  if (autoPersistQueries) {
    this_0.r47('persistedQuery');
    // Inline function 'com.apollographql.apollo.api.json.writeObject' call
    this_0.p40();
    this_0.r47('version').d41(1);
    this_0.r47('sha256Hash').b41(operation.operationId());
    this_0.q40();
  }
  if (sendEnhancedClientAwareness) {
    this_0.r47('clientLibrary');
    // Inline function 'com.apollographql.apollo.api.json.writeObject' call
    this_0.p40();
    this_0.r47('name').b41('apollo-kotlin');
    this_0.r47('version').b41('4.4.1');
    this_0.q40();
  }
  this_0.q40();
  var extensions = buffer_0.d3y();
  // Inline function 'kotlin.text.isEmpty' call
  if (!(charSequenceLength(extensions) === 0)) {
    queryParams.c5('extensions', extensions);
  }
  return queryParams;
}
function DefaultHttpRequestComposer$Companion$extensionsWriter$lambda(_this__u8e3s4) {
  return Unit_instance;
}
var DefaultHttpRequestComposer$Companion$buildPostBody$1Class;
function DefaultHttpRequestComposer$Companion$buildPostBody$1() {
  if (DefaultHttpRequestComposer$Companion$buildPostBody$1Class === VOID) {
    class $ {
      constructor($operationByteString) {
        this.y47_1 = $operationByteString;
        this.w47_1 = 'application/json';
        this.x47_1 = fromInt($operationByteString.v2());
      }
      g47() {
        return this.w47_1;
      }
      h47() {
        return this.x47_1;
      }
      j47(bufferedSink) {
        bufferedSink.l3y(this.y47_1);
      }
    }
    initMetadataForClass($);
    DefaultHttpRequestComposer$Companion$buildPostBody$1Class = $;
  }
  return DefaultHttpRequestComposer$Companion$buildPostBody$1Class;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        this.k47_1 = 'X-APOLLO-OPERATION-ID';
        this.l47_1 = 'X-APOLLO-OPERATION-NAME';
        this.m47_1 = 'Apollo-Require-Preflight';
        this.n47_1 = 'Accept';
        this.o47_1 = 'multipart/mixed;deferSpec=20220824, application/graphql-response+json, application/json';
        this.p47_1 = 'multipart/mixed;subscriptionSpec=1.0, application/graphql-response+json, application/json';
      }
      q47(_this__u8e3s4, parameters) {
        // Inline function 'kotlin.text.buildString' call
        // Inline function 'kotlin.apply' call
        var this_0 = StringBuilder().q1();
        this_0.r1(_this__u8e3s4);
        var hasQuestionMark = contains(_this__u8e3s4, '?');
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = parameters.q3().u1();
        while (_iterator__ex2g4s.v1()) {
          var element = _iterator__ex2g4s.w1();
          if (hasQuestionMark) {
            this_0.t1(_Char___init__impl__6a9atx(38));
          } else {
            hasQuestionMark = true;
            this_0.t1(_Char___init__impl__6a9atx(63));
          }
          this_0.r1(urlEncode(element.r3()));
          this_0.t1(_Char___init__impl__6a9atx(61));
          this_0.r1(urlEncode(element.s3()));
        }
        return this_0.toString();
      }
      z47(operation, customScalarAdapters, query, extensionsWriter) {
        var uploads = {_v: null};
        // Inline function 'com.apollographql.apollo.api.json.buildJsonByteString' call
        var buffer = new (Buffer())();
        var $this$buildJsonByteString = new (BufferedSinkJsonWriter())(buffer, null);
        uploads._v = composePostParams(Companion_instance, $this$buildJsonByteString, operation, customScalarAdapters, query, extensionsWriter);
        var operationByteString = buffer.z3x();
        var tmp;
        if (uploads._v.s1()) {
          tmp = new (DefaultHttpRequestComposer$Companion$buildPostBody$1())(operationByteString);
        } else {
          tmp = new (UploadsHttpBody())(uploads._v, operationByteString);
        }
        return tmp;
      }
      a48(apolloRequest) {
        var operation = apolloRequest.s42_1;
        var tmp0_elvis_lhs = apolloRequest.x42_1;
        var sendApqExtensions = tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs;
        var sendEnhancedClientAwarenessExtensions = apolloRequest.e43_1;
        var tmp1_elvis_lhs = apolloRequest.y42_1;
        var sendDocument = tmp1_elvis_lhs == null ? true : tmp1_elvis_lhs;
        var tmp2_elvis_lhs = apolloRequest.u42_1.b46(Key_getInstance());
        var customScalarAdapters = tmp2_elvis_lhs == null ? Key_getInstance().k45_1 : tmp2_elvis_lhs;
        var query = sendDocument ? operation.v47() : null;
        // Inline function 'com.apollographql.apollo.api.json.buildJsonMap' call
        var writer = new (MapJsonWriter())();
        composePostParams_0(Companion_instance, writer, operation, customScalarAdapters, sendApqExtensions, sendEnhancedClientAwarenessExtensions, query);
        var tmp = writer.s40();
        return (!(tmp == null) ? isInterface(tmp, KtMap()) : false) ? tmp : THROW_CCE();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var DefaultHttpRequestComposerClass;
function DefaultHttpRequestComposer() {
  if (DefaultHttpRequestComposerClass === VOID) {
    class $ {
      constructor(serverUrl) {
        this.b48_1 = serverUrl;
      }
      c48(apolloRequest) {
        var operation = apolloRequest.s42_1;
        var tmp0_elvis_lhs = apolloRequest.u42_1.b46(Key_getInstance());
        var customScalarAdapters = tmp0_elvis_lhs == null ? Key_getInstance().k45_1 : tmp0_elvis_lhs;
        // Inline function 'kotlin.collections.mutableListOf' call
        // Inline function 'kotlin.apply' call
        var this_0 = ArrayList().u2();
        var tmp = apolloRequest.s42_1;
        if (isInterface(tmp, Subscription())) {
          this_0.n2(new (HttpHeader())(Companion_instance.n47_1, Companion_instance.p47_1));
        } else {
          this_0.n2(new (HttpHeader())(Companion_instance.n47_1, Companion_instance.o47_1));
        }
        if (!(apolloRequest.w42_1 == null)) {
          this_0.z2(apolloRequest.w42_1);
        }
        var requestHeaders = this_0;
        var tmp1_elvis_lhs = apolloRequest.x42_1;
        var sendApqExtensions = tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
        var tmp2_elvis_lhs = apolloRequest.y42_1;
        var sendDocument = tmp2_elvis_lhs == null ? true : tmp2_elvis_lhs;
        var sendEnhancedClientAwarenessExtensions = apolloRequest.e43_1;
        var tmp3_elvis_lhs = apolloRequest.v42_1;
        var tmp_0;
        switch ((tmp3_elvis_lhs == null ? HttpMethod_Post_getInstance() : tmp3_elvis_lhs).b2_1) {
          case 0:
            tmp_0 = (new (Builder())(HttpMethod_Get_getInstance(), buildGetUrl(Companion_instance, this.b48_1, operation, customScalarAdapters, sendApqExtensions, sendDocument, sendEnhancedClientAwarenessExtensions))).i48(Companion_instance.m47_1, 'true');
            break;
          case 1:
            var query = sendDocument ? operation.v47() : null;
            var body = Companion_instance.z47(operation, customScalarAdapters, query, extensionsWriter(Companion_instance, operation.operationId(), sendApqExtensions, sendEnhancedClientAwarenessExtensions));
            // Inline function 'kotlin.let' call

            var it = (new (Builder())(HttpMethod_Post_getInstance(), this.b48_1)).j48(body);
            var tmp_1;
            if (startsWith(body.g47(), 'multipart/form-data')) {
              tmp_1 = it.i48(Companion_instance.m47_1, 'true');
            } else {
              tmp_1 = it;
            }

            tmp_0 = tmp_1;
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        var httpRequestBuilder = tmp_0;
        return httpRequestBuilder.k48(requestHeaders).r43(apolloRequest.u42_1).c37();
      }
    }
    initMetadataForClass($, 'DefaultHttpRequestComposer');
    DefaultHttpRequestComposerClass = $;
  }
  return DefaultHttpRequestComposerClass;
}
function buildUploadMap($this, uploads) {
  // Inline function 'com.apollographql.apollo.api.json.buildJsonByteString' call
  var buffer = new (Buffer())();
  var $this$buildJsonByteString = new (BufferedSinkJsonWriter())(buffer, null);
  // Inline function 'kotlin.collections.mapIndexed' call
  var this_0 = uploads.q3();
  // Inline function 'kotlin.collections.mapIndexedTo' call
  var destination = ArrayList().m2(collectionSizeOrDefault(this_0, 10));
  var index = 0;
  var _iterator__ex2g4s = this_0.u1();
  while (_iterator__ex2g4s.v1()) {
    var item = _iterator__ex2g4s.w1();
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var index_0 = checkIndexOverflow(_unary__edvuaz);
    var tmp$ret$0 = to(index_0.toString(), listOf(item.r3()));
    destination.n2(tmp$ret$0);
  }
  writeAny($this$buildJsonByteString, toMap(destination));
  return buffer.z3x();
}
function writeBoundaries($this, _this__u8e3s4, writeUploadContents) {
  _this__u8e3s4.n3y('--' + $this.n48_1 + '\r\n');
  _this__u8e3s4.n3y('Content-Disposition: form-data; name="operations"\r\n');
  _this__u8e3s4.n3y('Content-Type: application/json\r\n');
  _this__u8e3s4.n3y('Content-Length: ' + $this.m48_1.v2() + '\r\n');
  _this__u8e3s4.n3y('\r\n');
  _this__u8e3s4.l3y($this.m48_1);
  var uploadsMap = buildUploadMap($this, $this.l48_1);
  _this__u8e3s4.n3y('\r\n--' + $this.n48_1 + '\r\n');
  _this__u8e3s4.n3y('Content-Disposition: form-data; name="map"\r\n');
  _this__u8e3s4.n3y('Content-Type: application/json\r\n');
  _this__u8e3s4.n3y('Content-Length: ' + uploadsMap.v2() + '\r\n');
  _this__u8e3s4.n3y('\r\n');
  _this__u8e3s4.l3y(uploadsMap);
  // Inline function 'kotlin.collections.forEachIndexed' call
  var index = 0;
  var _iterator__ex2g4s = $this.l48_1.b5().u1();
  while (_iterator__ex2g4s.v1()) {
    var item = _iterator__ex2g4s.w1();
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var index_0 = checkIndexOverflow(_unary__edvuaz);
    _this__u8e3s4.n3y('\r\n--' + $this.n48_1 + '\r\n');
    _this__u8e3s4.n3y('Content-Disposition: form-data; name="' + index_0 + '"');
    if (!(item.i47() == null)) {
      _this__u8e3s4.n3y('; filename="' + item.i47() + '"');
    }
    _this__u8e3s4.n3y('\r\n');
    _this__u8e3s4.n3y('Content-Type: ' + item.g47() + '\r\n');
    var contentLength = item.h47();
    if (!(contentLength === -1n)) {
      _this__u8e3s4.n3y('Content-Length: ' + contentLength.toString() + '\r\n');
    }
    _this__u8e3s4.n3y('\r\n');
    if (writeUploadContents) {
      item.j47(_this__u8e3s4);
    }
  }
  _this__u8e3s4.n3y('\r\n--' + $this.n48_1 + '--\r\n');
}
function UploadsHttpBody$_get_contentLength_$ref_e5o4rd() {
  return (p0) => p0.h47();
}
var UploadsHttpBodyClass;
function UploadsHttpBody() {
  if (UploadsHttpBodyClass === VOID) {
    class $ {
      constructor(uploads, operationByteString) {
        this.l48_1 = uploads;
        this.m48_1 = operationByteString;
        this.n48_1 = uuid4().toString();
        this.o48_1 = 'multipart/form-data; boundary=' + this.n48_1;
        var tmp = this;
        tmp.p48_1 = lazy(() => {
          var countingSink = new (CountingSink())(blackholeSink());
          var bufferedCountingSink = buffer(countingSink);
          writeBoundaries(this, bufferedCountingSink, false);
          bufferedCountingSink.qc();
          var tmp = countingSink.r48_1;
          // Inline function 'kotlin.collections.sumOf' call
          var sum = 0n;
          var _iterator__ex2g4s = this.l48_1.b5().u1();
          while (_iterator__ex2g4s.v1()) {
            var element = _iterator__ex2g4s.w1();
            var tmp_0 = sum;
            var tmp$ret$0 = element.h47();
            sum = add(tmp_0, tmp$ret$0);
          }
          var tmp$ret$1 = sum;
          var result = add(tmp, tmp$ret$1);
          return result;
        });
      }
      g47() {
        return this.o48_1;
      }
      h47() {
        var tmp0 = this.p48_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('contentLength', 1, tmp, UploadsHttpBody$_get_contentLength_$ref_e5o4rd(), null);
        return tmp0.s3();
      }
      j47(bufferedSink) {
        writeBoundaries(this, bufferedSink, true);
      }
    }
    initMetadataForClass($, 'UploadsHttpBody');
    UploadsHttpBodyClass = $;
  }
  return UploadsHttpBodyClass;
}
var CountingSinkClass;
function CountingSink() {
  if (CountingSinkClass === VOID) {
    class $ {
      constructor(delegate) {
        this.q48_1 = delegate;
        this.r48_1 = 0n;
      }
      v3u(source, byteCount) {
        this.q48_1.v3u(source, byteCount);
        this.r48_1 = add(this.r48_1, byteCount);
      }
      q6() {
        this.q48_1.q6();
      }
      qc() {
        this.q48_1.qc();
      }
    }
    initMetadataForClass($, 'CountingSink');
    CountingSinkClass = $;
  }
  return CountingSinkClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  DefaultHttpRequestComposer as DefaultHttpRequestComposer3cbqxfvy17yg2,
  Companion_instance as Companion_instance2ugsdh0psp7vj,
};
//endregion

//# sourceMappingURL=DefaultHttpRequestComposer.mjs.map
